import { render, staticRenderFns } from "./BookIcon.vue?vue&type=template&id=4d625577&scoped=true&"
import script from "./BookIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BookIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d625577",
  null
  
)

export default component.exports